/** Supported UI locales — web (i18next) + mobile (I18nProvider). */
export const APP_LOCALES = [
  { code: 'en', label: 'English', flag: '🇬🇧', nativeLabel: 'English' },
  { code: 'lt', label: 'Lithuanian', flag: '🇱🇹', nativeLabel: 'Lietuvių' },
  { code: 'de', label: 'German', flag: '🇩🇪', nativeLabel: 'Deutsch' },
  { code: 'fr', label: 'French', flag: '🇫🇷', nativeLabel: 'Français' },
  { code: 'es', label: 'Spanish', flag: '🇪🇸', nativeLabel: 'Español' },
  { code: 'pl', label: 'Polish', flag: '🇵🇱', nativeLabel: 'Polski' },
  { code: 'ru', label: 'Russian', flag: '🇷🇺', nativeLabel: 'Русский' },
  { code: 'pt', label: 'Portuguese', flag: '🇵🇹', nativeLabel: 'Português' },
  { code: 'it', label: 'Italian', flag: '🇮🇹', nativeLabel: 'Italiano' },
  { code: 'nl', label: 'Dutch', flag: '🇳🇱', nativeLabel: 'Nederlands' },
  { code: 'uk', label: 'Ukrainian', flag: '🇺🇦', nativeLabel: 'Українська' },
] as const

export type AppLocale = (typeof APP_LOCALES)[number]['code']

export const DEFAULT_LOCALE: AppLocale = 'lt'

export const LOCALE_CODES: AppLocale[] = APP_LOCALES.map((l) => l.code)

export function localeMeta(code: string) {
  return APP_LOCALES.find((l) => l.code === code) ?? APP_LOCALES[0]
}

export function isAppLocale(code: string): code is AppLocale {
  return LOCALE_CODES.includes(code as AppLocale)
}

export function detectBrowserLocale(): AppLocale {
  if (typeof navigator === 'undefined') return DEFAULT_LOCALE
  const raw = (navigator.language || 'en').toLowerCase().split('-')[0]
  return isAppLocale(raw) ? raw : 'en'
}
